import React, { Component } from 'react'
import Config from '../../commons/config/Config.js'
import Loading from '../ui/Loading.js'

class EricInspeccionPanel extends Component {
	constructor(props) {
		super(props)
		this._mounted = false
		this.state = {
			loading: true,
			inspeccion: null,
			ocrReportando: {},   // { [tipoCampo]: true } while POST is in-flight
			ocrReportado: {},    // { [tipoCampo]: true } after success (optimistic)
		}
		this.reportarOcrError = this.reportarOcrError.bind(this)
	}

	componentWillMount() {
		this._mounted = true
		this.cargar()
	}

	componentWillUnmount() {
		this._mounted = false
	}

	cargar() {
		var component = this
		var url = Config.get('apiUrlBase') + '/v1/inspections/by-checklist/' + this.props.formularioId
		fetch(url, {
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return null
			if (response.status === 404) {
				component.setState({ loading: false })
				return null
			}
			return response.json()
		})
		.then(function(data) {
			if (!component._mounted || !data) return
			component.setState({ inspeccion: data, loading: false })
		})
		.catch(function() {
			if (component._mounted) component.setState({ loading: false })
		})
	}

	renderEstadoBadge(estado) {
		var clases = {
			COMPLETADA:  'badge badge-success',
			PROCESANDO:  'badge badge-warning',
			FALLIDA:     'badge badge-danger',
			RECHAZADA:   'badge badge-secondary',
		}
		var etiquetas = {
			COMPLETADA: 'Completada',
			PROCESANDO: 'Procesando',
			FALLIDA:    'Fallida',
			RECHAZADA:  'Rechazada',
		}
		var clase = clases[estado] || 'badge badge-secondary'
		return <span className={clase}>{etiquetas[estado] || estado}</span>
	}

	renderVehiculo(inspeccion) {
		var campos = [
			{ label: 'Patente',  valor: inspeccion.vehiculo_patente },
			{ label: 'Marca',    valor: inspeccion.vehiculo_marca   },
			{ label: 'Modelo',   valor: inspeccion.vehiculo_modelo  },
			{ label: 'Color',    valor: inspeccion.vehiculo_color   },
			{ label: 'Tipo',     valor: inspeccion.vehiculo_tipo    },
		].filter(function(c) { return !!c.valor })

		if (!campos.length) return null

		return (
			<div className="row mb-2">
				{campos.map(function(c, i) {
					return (
						<div key={i} className="col-auto mr-3">
							<small className="text-muted">{c.label}</small>
							<div><strong>{c.valor}</strong></div>
						</div>
					)
				})}
			</div>
		)
	}

	renderFlags(inspeccion) {
		var alertas = []

		if (inspeccion.flag_patente_discrepancia) {
			alertas.push('Discrepancia de patente detectada entre el video y el vehículo registrado.')
		}
		if (inspeccion.flag_movil_inactivo) {
			alertas.push('El vehículo estaba inactivo al momento de la inspección.')
		}
		if (inspeccion.flag_formulario_no_encontrado) {
			alertas.push('No se encontró el formulario asociado a esta inspección.')
		}

		if (!alertas.length) return null

		return (
			<div className="mb-2">
				{alertas.map(function(msg, i) {
					return (
						<div key={i} className="alert alert-warning alert-sm py-1 px-2 mb-1">
							<i className="fa fa-exclamation-triangle mr-1"></i>{msg}
						</div>
					)
				})}
			</div>
		)
	}

	renderImagenes(imagenes) {
		if (!imagenes || !imagenes.length) return null

		return (
			<div className="mb-3">
				<div className="mb-1">
					<strong><i className="fa fa-camera mr-1"></i>Imágenes ({imagenes.length})</strong>
				</div>
				<div style={{ display: 'flex', flexWrap: 'wrap' }}>
					{imagenes.map(function(img, i) {
						var url = img && img.url ? img.url : img
						return (
							<a key={i} href={url} target="_blank" rel="noopener noreferrer"
								style={{ marginRight: '8px', marginBottom: '8px', display: 'block' }}>
								<img
									src={url}
									alt={'Imagen ' + (i + 1)}
									style={{ width: '100px', height: '75px', objectFit: 'cover',
										borderRadius: '4px', border: '1px solid #ddd' }}
								/>
							</a>
						)
					})}
				</div>
			</div>
		)
	}

	reportarOcrError(inspeccionId, tipoCampo) {
		var component = this
		var reportando = Object.assign({}, this.state.ocrReportando)
		reportando[tipoCampo] = true
		this.setState({ ocrReportando: reportando })

		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + inspeccionId + '/ocr-errors/' + tipoCampo, {
			method: 'POST',
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return
			var reportando = Object.assign({}, component.state.ocrReportando)
			delete reportando[tipoCampo]
			if (response.ok) {
				var reportado = Object.assign({}, component.state.ocrReportado)
				reportado[tipoCampo] = true
				component.setState({ ocrReportando: reportando, ocrReportado: reportado })
			} else {
				component.setState({ ocrReportando: reportando })
			}
		})
		.catch(function() {
			if (!component._mounted) return
			var reportando = Object.assign({}, component.state.ocrReportando)
			delete reportando[tipoCampo]
			component.setState({ ocrReportando: reportando })
		})
	}

	renderOcrProblemas(inspeccion) {
		var problemas = inspeccion.ocr_problemas
		if (!problemas || !problemas.length) return null

		var etiquetas = { VIN: 'VIN', ODOMETRO: 'Odómetro', PATENTE: 'Patente' }
		var component = this

		return (
			<div className="mb-3">
				<div className="mb-1">
					<strong><i className="fa fa-exclamation-circle mr-1 text-warning"></i>Lecturas OCR con discrepancias</strong>
				</div>
				<table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.85rem' }}>
					<thead className="thead-light">
						<tr>
							<th>Campo</th>
							<th>Leído</th>
							<th>Esperado</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{problemas.map(function(p) {
							var campo = p.tipo_campo
							var yaReportado = p.reportado_incorrecto || !!component.state.ocrReportado[campo]
							var reportando  = !!component.state.ocrReportando[campo]
							return (
								<tr key={campo}>
									<td>{etiquetas[campo] || campo}</td>
									<td>{p.valor_leido || '—'}</td>
									<td>{p.valor_esperado || '—'}</td>
									<td>
										{yaReportado ? (
											<span className="badge badge-secondary">
												<i className="fa fa-check mr-1"></i>Reportado
											</span>
										) : (
											<button
												className="btn btn-xs btn-outline-warning"
												disabled={reportando}
												onClick={function() { component.reportarOcrError(inspeccion.id, campo) }}
											>
												{reportando
													? <span><i className="fa fa-spinner fa-spin mr-1"></i>Reportando...</span>
													: 'Reportar lectura incorrecta'
												}
											</button>
										)}
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		)
	}

	renderDanios(danios) {
		if (!danios || !danios.length) return null

		return (
			<div className="mb-2">
				<div className="mb-1">
					<strong><i className="fa fa-warning mr-1"></i>Daños detectados ({danios.length})</strong>
				</div>
				<table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.85rem' }}>
					<thead className="thead-light">
						<tr>
							<th>Zona</th>
							<th>Tipo de daño</th>
							<th>Severidad</th>
						</tr>
					</thead>
					<tbody>
						{danios.map(function(d, i) {
							return (
								<tr key={i}>
									<td>{d.zona || '—'}</td>
									<td>{d.tipo_danio || '—'}</td>
									<td>{d.severidad || '—'}</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		)
	}

	render() {
		if (this.state.loading) {
			return (
				<div className="text-center py-2">
					<Loading />
				</div>
			)
		}

		var inspeccion = this.state.inspeccion
		if (!inspeccion) return null

		var estado = inspeccion.estado

		return (
			<div className="card mt-3">
				<div className="card-content">
					<div className="card-body">
						<div className="d-flex align-items-center justify-content-between mb-3">
							<h5 className="card-title mb-0">
								<i className="fa fa-camera mr-1"></i>
								Eric IA — Inspección Automatizada
								<span className="ml-2">{this.renderEstadoBadge(estado)}</span>
							</h5>
							{inspeccion.reporte_pdf_url && (
								<a href={inspeccion.reporte_pdf_url} target="_blank" rel="noopener noreferrer"
									className="btn btn-sm btn-outline-primary">
									<i className="fa fa-file-pdf-o mr-1"></i>Ver reporte PDF
								</a>
							)}
						</div>

						{estado === 'PROCESANDO' && (
							<div className="text-muted">
								<i className="fa fa-spinner fa-spin mr-1"></i>
								Inspección en proceso — los resultados estarán disponibles en breve.
							</div>
						)}

						{estado === 'FALLIDA' && (
							<div className="alert alert-danger py-2">
								<i className="fa fa-times-circle mr-1"></i>
								No fue posible procesar la inspección. Revisá los logs o contactá a soporte.
							</div>
						)}

						{estado === 'RECHAZADA' && (
							<div className="alert alert-secondary py-2">
								<i className="fa fa-ban mr-1"></i>
								La inspección fue rechazada (duplicado o regla de negocio).
							</div>
						)}

						{estado === 'COMPLETADA' && (
							<div>
								{this.renderFlags(inspeccion)}
								{this.renderVehiculo(inspeccion)}
								{this.renderOcrProblemas(inspeccion)}
								{this.renderImagenes(inspeccion.imagenes)}
								{this.renderDanios(inspeccion.danios)}
								{(!inspeccion.imagenes || !inspeccion.imagenes.length) &&
								 (!inspeccion.danios   || !inspeccion.danios.length) && (
									<div className="text-muted">
										<i className="fa fa-check-circle mr-1"></i>
										Inspección completada. No se detectaron daños.
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		)
	}
}

export default EricInspeccionPanel
